import React, { useState } from "react";
import PostRequest from "../../service/PostRequest";
import './style.css'
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import InputFieldText from "../Widgets/Inputs/InputFieldText";
import InputFeildTextArea from "../Widgets/Inputs/InputFeildTextArea";



const TechnicalSupport = () => {

  const [email,setEmail ] = useState("");
  const [fullName,setFullName ] = useState("");
  const [message,setmessage ] = useState("");
  const [isWaitingForResponse, setIsWaitingForResponse] = useState(false);
  const [open, setOpen] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleFullNameChange = (e) => {
    setFullName(e.target.value);
  };

  const handleMessageChange = (e) => {
    setmessage(e.target.value);
  };

  const handlesendSupportRequest = async (type) => {
    setIsWaitingForResponse(true);
    const data = {
      country: null,
      customerEmail: email,
      customerFullName: fullName,
      message: message,
      supportType:type,
      appId:"Boss"
    };

    console.log("Email has been sent",data);
  
    try {
      const response = await PostRequest(`v1/notification/send/support/confirmation`, data, false);
      console.log(response);
      if (response === undefined) {
        console.log("Request failed");
        setIsWaitingForResponse(false);
      } else {
        setIsWaitingForResponse(false);
        handleClickOpen();
        console.log("Email sent successfull");
      }
    } catch (error) {
      setIsWaitingForResponse(false);
      console.error("Email sent failed:", error);
    }
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const footerContent = (
    <div>
        <Button label="Ok" icon="pi pi-check" onClick={() => setOpen(false)} autoFocus />
    </div>
);
 

  return (
    <div className="technical-support">

    <br/>
        <div className="contactus-title-container">Technical Support</div><br/>
        <div className="technical-support-icon-container"></div><br/>
        <div className="contacus-tagline">Send us an email if you have any questions
            about billing or any other thing</div><br/>
            <div className="contact-us-btn">Live chat</div>
            <div className="center-text-align">or</div>
<div className="contact-us-form">
<InputFieldText value={fullName} onChange={handleFullNameChange} label="Your Full name..."/>

<InputFieldText value={email} onChange={handleEmailChange} label="Your Email..."/>
<InputFeildTextArea value={message} onChange={handleMessageChange} label="Your Message..."/>
            
            <div className="contact-us-btn" onClick={() => handlesendSupportRequest("TECHNICAL_SUPPORT")} disabled={isWaitingForResponse}>{isWaitingForResponse ?
      <div>Please wait...</div>
     : 'Send' }</div>
            </div>

                <Dialog header="Request for Technical support has been recieved" visible={open} onHide={handleClose} footer={footerContent}
                style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
                <p className="m-0">
                      Thankyou for your request,one of the member for Boss team will contact you shortly.
                </p>
            </Dialog>
    </div>
  )
}

export default TechnicalSupport
